import { useField, useFormikContext } from "formik";
import { Form, InputGroup } from "react-bootstrap";

import React from "react";
import { ElementSize, ThemeColorsEnum } from "../../constants/enums";
import AppErrorMessage from "./ErrorMessage";
import FieldInfo from "./FieldInfo";
import FormFieldContainer from "./FormFieldContainer";
import AppFormLabel from "./FormLabel";
import Services from "../../services/services";
import Constants from "../../constants/constants";

const FormFileInputField = ({
  className,
  disabled = false,
  hasFloatingLabel,
  icon,
  info,
  label = null,
  LabelComponent,
  onFileSelect = () => { },
  onIconClick = () => { },
  placeholder,
  required,
  size = ElementSize.md,
  visible = true,
  acceptedTypes = Constants.defaultAcceptedFileTypes,
  ...otherProps
}) => {
  const [field] = useField(otherProps);

  const formik = useFormikContext();
  
  const { errors, setErrors, handleBlur, setFieldValue, touched } = formik;

  const allowedExts = acceptedTypes.map(({ ext }) => String(ext || "").toLowerCase());
  const joinedAcceptedTypes = acceptedTypes.map(({ type, ext }) => `${type}/${ext}`);

  if (!visible) return null;

  const handleFileSelected = (event) => {
  if (event.target.files?.[0]) {
    const file = event.target.files[0];

    if (file.size > parseInt(process.env.REACT_APP_FILE_SIZE_LIMIT)) {
      setErrors({file: `Selected file must be ${process.env.REACT_APP_FILE_SIZE_LIMIT / 1048576}MB or less.`});
      return Services.utility.toast("File too big", ThemeColorsEnum.error);
    }

    const fileExt = file.name.includes(".") ? file.name.split(".").pop().toLowerCase() : "";
    if (!allowedExts.includes(fileExt)) {
      setErrors({file: `Selected file must be one of the following types:${acceptedTypes.map(x => ` ${x.ext}`)}`});
      return Services.utility.toast("Wrong file type", ThemeColorsEnum.error);
    }

    setFieldValue(field.name, file);
    onFileSelect(file, formik);
  }
};


  const classes = `form-control-${size} ${className ?? ""}`.trim();
  return (
    <FormFieldContainer>
      <AppFormLabel label={label} required={required} visible={!!label} />
      {LabelComponent}
      <InputGroup>
        <Form.Control
          id="fileInput"
          type="file"
          accept={joinedAcceptedTypes}
          className={classes}
          disabled={disabled}
          name={field.name}
          onBlur={handleBlur}
          onChange={handleFileSelected}
          placeholder={hasFloatingLabel ? placeholder ?? label : placeholder}
        />
        {icon && (
          <span
            className={`input-group-text ${onIconClick === null ? "" : "cur-pointer"
              }`}
            onClick={onIconClick}
          >
            <i className={icon}></i>
          </span>
        )}
      </InputGroup>
      <div>
        <AppErrorMessage
          error={errors[field.name]}
          visible={touched[field.name] && errors[field.name]}
        />
      </div>
      <FieldInfo visible={!!info}>{info}</FieldInfo>
    </FormFieldContainer>
  );
};

export default FormFileInputField;
